import { Brand } from '@deltasierra/type-utilities';
import { OwnableIntegrationResource } from '../common';
import { FullAuditable, HasId } from '../common/model/traits';

export interface ApiToken extends HasId<ApiTokenId>, FullAuditable, OwnableIntegrationResource {
    token: string;
}

export type ApiTokenId = Brand<number, 'ApiTokenId'>;
export function asApiTokenId(apiTokenId: number): ApiTokenId {
    return apiTokenId as ApiTokenId;
}
